<template>
  <div>
  <b-card v-if="isNotEmpty" class="no-border">
    <b-form>
      <div class="form-group flex-inline-form-md">
        <b-input-group class="fill-width">
          <b-input-group-text slot="prepend">
            <i class="fa fa-search"></i>
          </b-input-group-text>
          <b-form-input type="text" placeholder="Search Issues by issue title"
            @input="onChangeSearchQuery($event)"
            v-model="searchQuery"></b-form-input>
        </b-input-group>
      </div>
    </b-form>
    <div
      v-if="isFiltered"
      @click="onRemoveFilter"
      class="remove--filter mb-2">
      <i class="fa fa-window-close" aria-hidden="true"></i>
      <span>Clear current filters and sorts.</span>
    </div>
    <b-card>
      <template slot="header">
        <!-- <ui-multiselect
          @select-option="onSelectConfirmation"
          :initSelect="initSelectConfirmations"
          :options="confirmationOptions"
          :putOnTopChecked="false"
          :multiple="true"
          :className="'pull-right ml-2'"
          :selectLabel="'Confirmation'"
          :title="'Filter by confirmation'"
          :label="'name'"></ui-multiselect> -->
        <ui-multiselect
          :initSelect="initSelectState"
          :options="stateOptions"
          :putOnTopChecked="false"
          :multiple="true"
          :className="'pull-right ml-2'"
          :selectLabel="'State'"
          :title="'Filter by state'"
          :label="'name'"></ui-multiselect>
        <ui-multiselect
          @select-option="onSelectSort"
          :initSelect="initSelectSort"
          :putOnTopChecked="false"
          :options="sortOptions"
          :className="'pull-right ml-2'"
          :selectLabel="'Sort'"
          :title="'Sort by'"
          :label="'name'"></ui-multiselect>
      </template>
      <b-table striped responsive
        :items="(is_data_loaded ? table.items : dataBeforeLoad)"
        :fields="table.fields"
        :class="is_data_loaded ? '' : 'show__blur'">
        <template #cell(id)="data">
          <router-link :to="`/issues/${data.value}`">{{data.value}}</router-link>
        </template>
        <template #cell(title)="data">
          {{data.value}}
        </template>
        <template #cell(status)="data">
            <b-badge pill variant="success" v-if="data.value == 'COMPLETE'">{{data.value}}</b-badge>
            <b-badge pill variant="warning" v-if="data.value == 'INCOMPLETE'">{{data.value}}</b-badge>
        </template>
        <template #cell(vehicle)="data">
          <div>
          <router-link
            :to="`/vehicles/${data.item.vehicle.id}`">{{data.item.vehicle.reg_no}}</router-link>
            <div class="small text-muted"><i class="fa fa-building-o" aria-hidden="true"></i> {{get(data, 'item.vehicle.company.name')}} </div>
          </div>
        </template>
        <template #cell(driver)="data">
          <router-link
            :to="`/employees/${getDriver(data.item, 'id')}`">{{getDriver(data.item, 'name')}}</router-link>
        </template>
        <template #cell(created_at)="data">
          {{formatDateTime(data.value)}}
        </template>
      </b-table>
      <div
        class="show__loading"
        v-if="!is_data_loaded"
        :style="`height: ${dataBeforeLoad.length*75+50}px;`">
        <i
          class="fa fa-spinner fa-pulse fa-4x fa-modify"
          alt="Loading"
          :style="`margin-top: ${(dataBeforeLoad.length*75+50)/2}px;`"></i>
      </div>
    </b-card>
    <nav aria-label="Shipment pagination" class="pull-right">
      <ul class="pagination">
        <li class="page-item" :class="{disabled: prevDisabled}">
          <a class="page-link" href="#" @click.prevent="prevPage()"><span aria-hidden="true">&laquo;</span> Previous</a>
        </li>
        <li class="page-item" :class="{disabled: nextDisabled}">
          <a class="page-link" href="#" @click.prevent="nextPage()">Next <span aria-hidden="true">&raquo;</span></a>
        </li>
      </ul>
    </nav>
  </b-card>
  <b-alert show v-else-if="loaded">There's no issues data.</b-alert>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import { cloneDeep, get, isEmpty, isObject, omit, last, throttle } from 'lodash';
import ConfirmChecklist from '@/components/ConfirmChecklist';
import UiMultiselect from '@/components/UiMultiselect';

export default {
  name: 'issue_list',
  mixins: [dateMixin],
  components: {
    UiMultiselect,
    ConfirmChecklist,
  },
  data() {
    return {
      shipmentFile: true,
      fileUpload: null,
      uploadProcessed: false,
      uploadResult: false,
      loaded: false,
      searchQuery: '',
      lastData: null,
      lastDataAr: [],
      selectedCompany: null,
      initSelectCompany: null,
      selectedOrigin: null,
      initSelectOrigin: null,
      selectedVehicle: null,
      initSelectVehicle: null,
      currentSort: null,
      initSelectSort: null,
      selectedStates: [],
      initSelectState: [],
      selectedConfirmations: [],
      initSelectConfirmations: null,
      locationsByCompanyId: [],
      vehiclesByCompanyId: [],
      dataBeforeLoad: [],
      uploadResultText: '',
      sortOptions: [
        { id: 1, value: 'ID.ASC', name: 'ID 0-9' },
        { id: 2, value: 'ID.DESC', name: 'ID 9-0' },
        { id: 3, value: 'CREATED_AT.DESC', name: 'Last Created' },
        { id: 4, value: 'CREATED_AT.ASC', name: 'Oldest Created' },
      ],
      stateOptions: [
        { id: 1, value: 'CREATED', name: 'Created' },
        { id: 2, value: 'FINISH_LOADING', name: 'Finish Loading' },
        { id: 3, value: 'ON_PROCESS', name: 'On Process' },
        { id: 4, value: 'FINISH', name: 'Finish' },
      ],
      confirmationOptions: [
        { id: 1, value: 'DRIVER', name: 'Driver' },
        { id: 2, value: 'LOADER', name: 'Loader' },
        { id: 3, value: 'W_OPERATOR', name: 'Operator' },
      ],
      table: {
        fields: ['id', 'title', 'status', 'vehicle', 'driver', 'created_at'],
        items: [],
      },
      filter: {
        companyField: true,
        originField: true,
        vehicleField: true,
        confirmationField: true,
        stateField: true,
      },
      sortType: null,
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'issues', name: 'Issue' },
    ]);
    this.$store.commit('issues/CLEAR_QUERY');
    this.$store.dispatch('issues/LOAD_DATA').then(() => {
      this.loaded = true;
      this.initFromUrl();
    });
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
    issues() {
      return this.$store.getters['issues/issues'];
    },
    isNotEmpty() {
      return true;
    },
    prevDisabled() {
      return this.lastData === null;
    },
    nextDisabled() {
      return this.issues.length < 2;
    },
    noFileUploadChosen() {
      return this.fileUpload == null;
    },
    uploadAlert() {
      return this.uploadResult ? 'success' : 'danger';
    },
    company_count_all() {
      return this.$store.getters['companies/count_all'];
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    isFiltered() {
      const filtered =
        !isEmpty(this.currentSort);
      return filtered;
    },
    disableLocationElem() {
      return isEmpty(this.selectedCompany) || isEmpty(this.locationsByCompanyId);
    },
    disabledVehicleElem() {
      return isEmpty(this.selectedCompany) || isEmpty(this.vehiclesByCompanyId);
    },
    is_data_loaded() {
      return this.$store.getters['issues/dataLoaded'];
    },
    issueGetters() {
      return this.$store.getters['issues/loadIssue'];
    },
    isFetched() {
      return this.issueGetters === 'LOADED';
    },
  },
  watch: {
    issues(data) {
      this.table.items.splice(0);
      data.forEach((d) => {
        this.table.items.push(d);
      });
    },
  },
  methods: {
    initFromUrl() {
      const { query } = this.$route;

      if (query.q !== undefined) {
        this.onChangeSearchQuery(query.q, true);
      }

      if (query.sort !== undefined) {
        this.onSelectSort(query.sort, true);
      }

      this.loadData();
    },
    resetPagination() {
      this.lastData = null;
      this.lastDataAr = [];
    },
    updateSearchQuery: throttle((context, searchTerm) => {
      const searchQuery = searchTerm.trim();
      context.resetPagination();
      context.$store.commit('issues/SET_QUERY_SEARCH', searchQuery);
      context.loadData();
    }, 500, {
      leading: false,
    }),
    loadData() {
      this.dataBeforeLoad = cloneDeep(this.issues);
      this.$store.commit('issues/SET_QUERY_LAST_DATA', this.lastData);
      if (this.searchQuery.trim() !== '') {
        return this.$store.dispatch('issues/FIND_DATA');
      }
      return this.$store.dispatch('issues/LOAD_DATA');
    },
    onRemoveFilter() {
      const unSelectButtons = document.querySelectorAll('.filtered .ui-unselect--option');
      unSelectButtons.forEach((el) => {
        el.click();
      });
    },
    onSelectSort(newValue, fromInit = false) {
      const { query } = this.$route;
      const sortValue = isObject(newValue) ? newValue.value || null : newValue;
      this.currentSort = sortValue;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            sort: sortValue,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['sort']),
          },
        });
        return;
      }

      const { id } = this.sortOptions.find(s => s.value === sortValue);
      this.$store.commit('issues/SET_QUERY_SORT', sortValue);

      if (!fromInit) {
        this.loadData();
      } else {
        this.initSelectSort = id;
      }
    },
    prevPage() {
      this.lastDataAr.pop();
      if (this.lastDataAr.length) {
        this.lastData = last(this.lastDataAr);
      } else {
        this.lastData = null;
      }
      this.loadData();
    },
    nextPage() {
      const issue = last(this.issues);
      this.lastDataAr.push(issue.id);
      this.lastData = issue.id;
      this.loadData();
    },
    getConfirmation(data, key) {
      return data.confirmations.find(c => c.key === key);
    },
    getDriver(data, key) {
      const driverVehicle = get(data, 'vehicle.driver');
      const driver = get(data, 'driver');
      let value = '-';

      if (!isEmpty(driverVehicle) || !isEmpty(driver)) {
        value = isEmpty(driver) ? driverVehicle[key] : driver[key];
      }

      return value;
    },
    get(obj, key) {
      return get(obj, key);
    },
    onChangeSearchQuery(newValue, fromInit = false) {
      this.$store.commit('issues/SET_QUERY_SEARCH', newValue);
      if (!isEmpty(newValue)) {
        this.$router.push({ query: { ...this.$route.query, q: newValue } });
      } else {
        this.$router.push({ query: { ...omit(this.$route.query, ['q']) } });
      }
      this.searchQuery = newValue;

      if (!fromInit) {
        this.updateSearchQuery(this, newValue);
      }
    },
  },
};
</script>
<style lang="sass">
.table td
  vertical-align: middle
.remove--filter
  font-weight: bold;
  cursor: pointer;
  color: #e66f6f;
.remove--filter
  i
    font-size: 17px;
.remove--filter:hover
  color: #0366d6;
@media screen and (max-width: 320px)
  .ui-dropdown-modal-holder
    width: 250px !important
</style>

<style lang="sass" scoped>
.show__loading
  height: 800px
  top: 75px
  width: 96.5%
  position: absolute
  opacity: 0.3
  background-color: #9E9E9E

  >img
    height: 50px
    width: 50px
    margin-left: 50%

.show__blur
  -webkit-filter: blur(1px)
  -moz-filter: blur(1px)
  -ms-filter: blur(1px)
  -o-filter: blur(1px)
  filter: blur(1px)

.fa-modify
  color: #000000;
  margin-left: 45%;
</style>



// WEBPACK FOOTER //
// src/views/pages/issues/List.vue